import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem as ReachMenuItem } from '@reach/menu-button';
import { MenuItem } from '../Menu';
import wrapForReachUI from './wrapForReachUI';

const PreparedMenuItem = wrapForReachUI(MenuItem);

const DropdownItem = ({ onSelect, ...props }: any) => {
  return (
    <ReachMenuItem
      as={PreparedMenuItem}
      {...props}
      onSelect={(...args: any[]) => {
        if (typeof onSelect === 'function') onSelect(...args);
      }}
    />
  );
};

(DropdownItem as any).propTypes = {
  children: PropTypes.node,
  onSelect: PropTypes.func,
};

export default DropdownItem;
